import { createChainedObserver } from "../utils/chain-observer";

export function landscapeDesignTemplate($) {
    const $list = $('[data-list-reveal]');

    if ($list) {
        createChainedObserver({
            elements: $list.toArray(),
            threshold: 0.2,
            onIntersect: ({ entry, index, elements }) => {
                const $el = $(entry.target);
                const $next = $(elements[index + 1]);

                $el.addClass('opacity-100');

                if (!$next.length) return;

                const $marker = $el.find('marker');
                if (!$marker.length) return;

                const markerRect = $marker[0].getBoundingClientRect();
                const nextRect   = $next[0].getBoundingClientRect();
                const distance   = nextRect.top - markerRect.bottom;

                $marker.css('--connector-height', `${distance}px`);

                return new Promise(resolve => {
                    setTimeout(resolve, 750);
                });
            }
        });
    }

    const $imageSections = $('[data-image-shutter]');

    if ($imageSections) {
        $imageSections.toArray().forEach(section => {
            createChainedObserver({
                elements: $(section).find('[data-image]').toArray(),
                threshold: 0.5,
                onIntersect: ({ entry, index, elements }) => {
                    const $el = $(entry.target);
                    const $overlay = $el.find('span');

                    $overlay.css('--tw-translate-y', '-100%');

                    return new Promise(resolve => {
                        setTimeout(resolve, 200);
                    });

                }
            })
        });
    }
}